import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "missing-retail-aml-modal__message" }

import { type PropType } from 'vue';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


const __default__ = {
  name: 'MissingRetailAmlModal',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  emits: ["go-to-form"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "missing-retail-aml-modal",
    "can-close": false,
    wide: true,
    variant: __props.variant,
    title: _ctx.$t('ui.missingRetailAmlModal.title')
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('ui.missingRetailAmlModal.message')), 1)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        variant: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('go-to-form')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ui.missingRetailAmlModal.goToForm')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})